/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../modules/auth';
import { RequestService } from './components/RequestService';
import useSize from '../../hooks/useSize';
import { TableReportServices } from './components/ScreenServices/components/TableReportServices';
//import { MyPortal } from './components/my-portal'

const requestServicesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Início',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const RequestServicesPage: FC = () => {
    const [refreshPage, setRefreshPage] = useState<boolean>(false);
    const location = useLocation();
    // Abre direto na aba de nova solicitação quando vem do botão "Solicitar" do dashboard
    const [openRequestTab] = useState<boolean>(!!(location.state as any)?.openRequest);
    const [largura, setLargura] = useState(window.innerWidth);
    const user = useAuth()
    const {height} = useSize();
    const [pages, setPages] = useState<number>(openRequestTab ? 1 : 0);
    const showMobileTitle = largura < 992 && user.currentUser?.role?.slug === 'CLIENTE';


  return (
    <div 
      className='column g-5 g-xl-8 card p-7' 
      style={{
        height: height <= 750 ? '68vh' 
        : height <= 850 ? '70vh'
        : height <= 930 ? '70vh'
        : '72vh',
        paddingBottom: '1rem'
      }}>
       <div style={{height: '100%'}}>
          <div style={{display: 'flex'}}>
            <ul className={
              `nav nav-stretch nav-line-tabs 
              nav-line-tabs-2x border-transparent fw-bolder 
              flex-nowrap ${largura < 1200 ? "" : "mb-5"} fs-${largura < 1200 ? '7' : '5'}` 
            } 
              style={{
                //overflowX: 'auto',
                display: 'flex',
                height: 'auto',
                width: '100%', 
                justifyContent: 'space-between',
              }}>
              <li className="nav-item">
                <a
                  className={`nav-link text-active-primary me-6 ${openRequestTab ? "" : "active"}`}
                  data-bs-toggle="tab"
                  href="#kt_tab_pane_5"
                  onClick={() => setPages(0)}
                >
                  
                  {pages == 1 ? 
                  <span>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-3 me-2'
                    />
                    Voltar
                  </span> : showMobileTitle ? (
              <span className='d-inline-flex align-items-center fw-bolder fs-6 text-primary'>
                Serviços
                <i className='bi bi-chevron-right fs-8 text-gray-500 mx-2' aria-hidden />
                <span className='text-gray-800'>S.S</span>
              </span>
                  ) : <></>}
                </a>
              </li>

              <li className="nav-item">
                {/* <a
                  className="nav-link text-active-primary me-6"
                  data-bs-toggle="tab"
                  href="#kt_tab_pane_2"
                >
                  Solicitação de Serviço
                </a> */}

                <a
                  href='#kt_tab_pane_2'
                  data-bs-toggle="tab"
                  className={`btn btn-sm btn-light-primary nav-link text-muted fw-bold ${largura < 992 ? 'py-2 px-3 fs-8' : ''} ${openRequestTab ? 'active' : ''}`}
                  onClick={() => setPages(1)}
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className={largura < 992 ? 'svg-icon-5' : 'svg-icon-3'} />
                  Solicitação de Serviço
                </a>
              </li>
            </ul>
            {/* <div>
              <a
                className="nav-link text-active-primary me-6"
                data-bs-toggle="tab"
                href="#kt_tab_pane_2"
              >
                Solicitação de Serviço
              </a>
            </div> */}
          </div>

          <div className="tab-content" id="myTabContent" style={{height: '92%'}}>
            <div
              className={`tab-pane fade ${openRequestTab ? "" : "active show"}`}
              id="kt_tab_pane_5"
              role="tabpanel"
              style={{height: '100%'}}
            >
              <TableReportServices 
                className={'w-100'}
                refresh={() => {}}
                refreshPage={refreshPage}
                setRefreshPage={setRefreshPage}
              />
            </div>

            <div className={`tab-pane fade ${openRequestTab ? "active show" : ""}`} id="kt_tab_pane_2" role="tabpanel">
              <RequestService 
                refreshPage={refreshPage}
                setRefreshPage={setRefreshPage}
              />
            </div>       
          </div>
       </div>
    </div>
  )
}

const RequestServicesWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={requestServicesBreadcrumbs}>Minhas solicitações de serviços</PageTitle>
      <RequestServicesPage />
    </>
  )
}

export {RequestServicesWrapper}
// function toggleToast(arg0: string, arg1: string) {
//     throw new Error('Function not implemented.');
// }

